import { createFileRoute } from "@tanstack/react-router";
import { TrendingUp, Rocket, Home, Building2 } from "lucide-react";
import { PlatformHub } from "@/components/marketing/PlatformHub";
import { alternateLinkList } from "@/lib/i18n/locale";
import heroImg from "@/assets/networking.jpg";

export const Route = createFileRoute("/vi/solutions/")({
  head: () => ({
    meta: [
      { title: "Giải pháp — banana.cards" },
      { name: "description", content: "Banana được tinh chỉnh cho cách đội nhóm của bạn thực sự làm việc — bán hàng, nhà sáng lập, bất động sản và doanh nghiệp." },
      { property: "og:title", content: "Giải pháp — banana.cards" },
      { property: "og:description", content: "Đội bán hàng, nhà sáng lập, bất động sản, doanh nghiệp — xem Banana phù hợp với bạn như thế nào." },
      { property: "og:image", content: heroImg },
      { property: "og:locale", content: "vi_VN" },
    ],
    links: alternateLinkList("/solutions", "vi"),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: "Giải pháp — banana.cards",
          description: "Banana được tinh chỉnh cho cách đội nhóm của bạn thực sự làm việc — bán hàng, nhà sáng lập, bất động sản và doanh nghiệp.",
          url: "https://banana.cards/vi/solutions",
          isPartOf: { "@type": "WebSite", name: "banana.cards", url: "https://banana.cards" },
        }),
      },
    ],
  }),
  component: Page,
});

function Page() {
  return (
    <PlatformHub
      eyebrow="Giải pháp"
      title="Được thiết kế cho cách"
      italic="đội nhóm của bạn thực sự làm việc."
      description="Cùng một nền tảng Banana, được tinh chỉnh cho bốn cách làm việc cụ thể. Chọn cái gần nhất với bạn — chúng tôi sẽ chỉ ra chính xác các thẻ, CRM và ứng dụng phù hợp."
      heroImage={heroImg}
      features={[
        {
          title: "Cho đội Bán hàng",
          desc: "Chốt nhiều giao dịch hơn trong ít thời gian hơn. Ghi nhận mọi khách hàng tiềm năng trong vài giây, tự động theo dõi và giữ pipeline luôn chính xác.",
          href: "/vi/solutions/sales",
          icon: TrendingUp,
          bullets: ["Ghi nhận khách hàng tức thì", "Bản nháp theo dõi bằng AI", "Pipeline tự cập nhật"],
        },
        {
          title: "Cho Nhà sáng lập",
          desc: "Đừng bao giờ mất kết nối nữa. Bộ não thứ hai của bạn cho mỗi buổi cà phê, hội nghị và giới thiệu.",
          href: "/vi/solutions/founders",
          icon: Rocket,
          bullets: ["Trí nhớ AI theo từng liên hệ", "Nhắc nhở thông minh", "Một hồ sơ, mọi kênh"],
        },
        {
          title: "Cho Bất động sản",
          desc: "Luôn hiện diện trong tâm trí khách hàng. Niêm yết, đặt lịch và đánh giá trên một tấm thẻ chỉ cần chạm.",
          href: "/vi/solutions/real-estate",
          icon: Home,
          bullets: ["Đặt lịch ngay trên thẻ", "Tự động hóa đánh giá", "Ghi nhận niêm yết & liên hệ"],
        },
        {
          title: "Cho Doanh nghiệp",
          desc: "SSO, bảo mật và tính phí theo chỗ ngồi. Triển khai thẻ có thương hiệu cho hàng ngàn người trong một ngày.",
          href: "/vi/solutions/enterprise",
          icon: Building2,
          bullets: ["SAML SSO & SCIM", "Mẫu thương hiệu ở quy mô lớn", "Nhật ký kiểm toán & DPA"],
        },
      ]}
      outro={{ title: "Không chắc cái nào phù hợp?", italic: "Hãy trò chuyện.", description: "Cho chúng tôi biết cách đội của bạn làm việc — chúng tôi sẽ ánh xạ Banana vào đó trong 15 phút." }}
    />
  );
}